import { render, staticRenderFns } from "./listaFiltraComponente.vue?vue&type=template&id=8265a0da&scoped=true"
import script from "./listaFiltraComponente.vue?vue&type=script&lang=js"
export * from "./listaFiltraComponente.vue?vue&type=script&lang=js"
import style0 from "./listaFiltraComponente.vue?vue&type=style&index=0&id=8265a0da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8265a0da",
  null
  
)

export default component.exports